import { type FC } from 'react';
import { Form } from 'antd';
import { Modal, Select, Textarea } from '@g2u/ui-kit';
import { type ProfileNoteType, type TechnicianNote } from 'types';

type LinkOptions = {
  label: string;
  options?: {
    label: string;
    value: string;
  }[];
};

type Props = {
  note: TechnicianNote | null;
  isOpen: boolean;
  isLoading: boolean;
  linkOptions: LinkOptions[];
  types?: ProfileNoteType[];
  onSubmit: (values: TechnicianNoteModal.FormValues) => void;
  onClose: () => void;
};

export const TechnicianNoteModal: FC<Props> = (props) => {
  const [form] = Form.useForm();
  const { isOpen, linkOptions, types, onSubmit, isLoading, onClose, note } = props;

  const handleFormSubmit = (values: TechnicianNoteModal.FormValues) => {
    onSubmit({ noteId: note?.ID, ...values });
  };

  return (
    <Modal.$
      dataTestId="technician-note-modal"
      open={isOpen}
      title={note ? 'Edit Note' : 'New Note'}
      okText="Save"
      onCancel={onClose}
      onOk={form.submit}
      cancelButtonProps={{ disabled: isLoading }}
      okButtonProps={{ disabled: isLoading }}
    >
      <Form
        form={form}
        onFinish={handleFormSubmit}
        labelCol={{ style: { width: 130 } }}
        labelAlign="left"
        layout="horizontal"
        disabled={isLoading}
        preserve={false}
      >
        <Textarea.$ name="notes" label="Note" rules={[{ required: true }]} required initialValue={note?.notes} />
        <Select.$
          name="note_type"
          label="Note Type"
          rules={[{ required: true }]}
          required
          initialValue={note?.note_type.toString()}
          options={types?.map((type: ProfileNoteType) => ({
            value: type.ID.toString(),
            label: type.name,
          }))}
        />
        {!note && <Select.$ name="notesLinkTypes" mode="multiple" label="Links" options={linkOptions} />}
      </Form>
    </Modal.$>
  );
};

export namespace TechnicianNoteModal {
  export type FormValues = {
    notes: string;
    note_type: number;
    notesLinkTypes: string[];
    noteId?: number;
  };
}
